angular.module('gym.components').directive('integrapayPaymentDetails', function() {
  return {
    restrict: 'EA',
    scope: {
      gym: '=',
      paymentMethods: '=',
      permissions: '=',
      remove: '&'
    },
    template: require('templates/components/contacts/wallet/integrapay_payment_details.html.slim'),
    controller: ["$scope", "AdminUserService", function($scope, AdminUserService) {
      return $scope.adminHasPermission = AdminUserService.has;
    }]
  };
});
